<script>
import moment from 'moment';
import {defineComponent, watch, ref, computed} from "vue";
import {storeToRefs} from "pinia";
import {useCarStore} from "@/composables/cars";
import {useDriverStore} from "@/composables/drivers";
import {useEventStore} from "@/composables/events";
import {useLayoutsStore} from "@/composables/layouts";
import {useCharacteristicsStore} from "@/composables/characteristics";
import CarsModal from "@/components/modals/CarsModal.vue";
import DriverModal from "@/components/modals/DriversModal.vue";

export default defineComponent({
  setup() {
    const characteristicsStore = useCharacteristicsStore();
    const {characteristics} = storeToRefs(characteristicsStore);

    const signNumberFilter = ref('');
    const nameFilter = ref('');

    const carStore = useCarStore();
    const eventStore = useEventStore();

    const driverStore = useDriverStore();
    const {drivers} = storeToRefs(driverStore);

    const {cars} = storeToRefs(carStore);
    // eslint-disable-next-line no-unused-vars
    const {event, eventCar, updateEventForm} = storeToRefs(eventStore);

    const getStatus = eventStore.getStatusRequest;
    const updateDriversSelected = eventStore.updateDriversSelected;

    const saveAction = async (action) => {
      await eventStore.saveHandle(action);
      event.value.status = action;
      alert('Изменения приняты');
    }

    const formatDate = (date, format) => {
      return moment(date).format(format);
    };

    watch(
        () => event,
        () => {
        }
    )

    const filteredCars = computed(() => {
      return cars.value.filter(car => {
        if (!signNumberFilter.value.length) {
          return car;
        }
        const regex = new RegExp(signNumberFilter.value);
        if (regex.test(car.signNumber)) {
          return car;
        }
      })
    });

    const filteredDrivers = computed(() => {
      return drivers.value.filter(driver => {
        if (!nameFilter.value.length) {
          return driver;
        }
        const regex = new RegExp(nameFilter.value);
        if (regex.test(driver.name)) {
          return driver;
        }
      })
    });

    const setFilterSignNumber = (e) => {
      signNumberFilter.value = String(e.target.value)
    };

    const setFilterName = (e) => {
      nameFilter.value = String(e.target.value)
    };

    const startDate = computed(() => {
      // @ts-ignore
      return moment(event.value.technics[0].treads[0].start_date).format('HH:mm');
    });

    const endDate = computed(() => {
      // @ts-ignore
      return moment(event.value.technics[0].treads[event.value.technics[0].treads.length - 1].end_date).format('HH:mm');
    });

    const companies = computed(() => {
      return event.value.company;
    });

    const departments = computed(() => {
      return event.value.departments
    });

    return {
      cars: filteredCars,
      drivers: filteredDrivers,
      event,
      eventCar,
      getStatus,
      formatDate,
      saveAction,
      updateEventForm,
      characteristics,
      updateDriversSelected,
      signNumberFilter,
      nameFilter,
      setFilterSignNumber,
      setFilterName,
      startDate,
      endDate,
      companies,
      departments,
    };
  },
  components: {
    CarsModal,
    DriverModal,
  },
  async beforeRouteEnter(to, from, next) {
    const {id} = to.params;
    const eventStore = useEventStore();
    await eventStore.loadEvent(id);

    const layoutsStore = useLayoutsStore();
    layoutsStore.changeLayout('layout');
    next(true);
  },
});
</script>

<template>
  <div class="container my-2">
    <div class="row">
      <div class="col-lg-12">
        <div class="row mb-2">
          <div class="col-6">
            <span class="h3" style="white-space: nowrap">
              Просмотр заявки
            </span>
          </div>
          <div class="col-6">
            <div class="d-flex justify-content-end">
              <router-link :to="{name: 'events'}" class="text-black">
                <button class="btn btn-sm btn-outline-secondary">
                  <i class="bi bi-arrow-left"></i>
                </button>
              </router-link>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="card-title mb-2">
              <span class="fw-bold">
                Информация по заявке
              </span>
            </div>

            <div class="information-container mb-2">
              <div class="row">
                <div class="col-6">
                  Номер заявки
                </div>
                <div class="col-6 text-end">
                  <span class="fw-bold">{{ event.requestCarId }}</span>
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  Статус
                </div>
                <div class="col-6 text-end">
                  <span class="fw-bold">{{ getStatus(event.status) }}</span>
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  Дата
                </div>
                <div class="col-6 text-end">
                  <span class="fw-bold">{{ formatDate(event.date, 'DD.MM.YYYY') }}</span>
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  Время
                </div>
                <div class="col-6 text-end">
                  <span class="fw-bold">
                    {{ startDate }} - {{ endDate }}
                  </span>
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  Предприятие
                </div>
                <div class="col-6 text-end">
                  <span class="fw-bold" v-html="companies"/>
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  Участок
                </div>
                <div class="col-6 text-end">
                  <span class="fw-bold" v-html="departments"/>
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  <i class="bi bi-signpost-split"></i> Маршрут
                </div>
                <div class="col-6 text-end">
                  <template v-if="event">
                    <ul v-for="(technic, i) in event.technics" :key="i" class="list-unstyled">
                      <template v-for="(tread, j) in technic.treads" :key="j">
                        <template v-for="(task, k) in tread.tasks" :key="k">
                          <li v-if="task.geo_task_type === 10">
                            {{ task.geo_tasks_name }};
                          </li>
                        </template>
                      </template>
                    </ul>
                  </template>
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  <span class="fw-bold">
                    Техника
                  </span>
                </div>
                <div class="col-6 text-end">
                  <span class="fw-bold">{{ event.kindName }}</span>
                </div>
              </div>
            </div>

            <div class="information-container mb-2">
              <div class="row">
                <div class="col-6">
                  Предоставляемая техника
                </div>
                <div class="col-6 text-end">
                  <div class="d-flex flex-column">
                    <CarsModal
                        @setCarToggle="car => updateEventForm.car.id = car"
                        @filter:signNumber="setFilterSignNumber"
                        :sign-number-filter="signNumberFilter"
                        :car="updateEventForm.car.id"
                        :cars="cars"
                    >
                      <template v-slot:action="{open}">
                        <button @click="open" class="btn btn-sm btn-primary">Выбрать технику</button>
                      </template>
                    </CarsModal>

                    <template v-if="updateEventForm.car.id">
                      <span>
                        <i class="bi bi-car-front"></i> {{
                          eventCar
                              ? eventCar.brandName + ' ' + (eventCar.signNumber || eventCar.garageNumber)
                              : ''
                        }}
                      </span>

                      <DriverModal
                          @toggleDrivers="updateDriversSelected"
                          @filter:name="setFilterName"
                          :filter-name="nameFilter"
                          :drivers="drivers"
                          :selected="updateEventForm.car.drivers"
                      >
                        <template v-slot:action="{open}">
                          <a @click="open" class="text-decoration-none" href="javascript:void(0)">
                            + Водители
                            {{ updateEventForm.car.drivers.length ? `(${updateEventForm.car.drivers.length})` : '' }}
                          </a>
                        </template>
                      </DriverModal>
                    </template>
                  </div>
                </div>
              </div>
            </div>

            <hr>

            <div class="card-title mb-2">
              <span class="fw-bold">
                Объёмы
              </span>

              <table v-if="event.technics.length" class="table">
                <thead class="bg-primary">
                <tr>
                  <th>Название</th>
                  <th>План</th>
                  <th>Факт</th>
                </tr>
                </thead>

                <tbody>
                <tr v-for="item in Object.keys(event.collapseData)" :key="item">
                  <td>
                    {{ characteristics[item] }}
                  </td>
                  <td>
                    {{ event.collapseData[item] ?? '' }}
                  </td>
                  <td>
                    <input v-model="updateEventForm.parameters[item]" type="text" class="form-control form-control-sm">
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="actions d-flex justify-content-end">
              <button
                  v-if="event.status === 'wait'"
                  :disabled="!updateEventForm.car.id || !updateEventForm.car.drivers.length"
                  @click="saveAction('agree')"
                  ref="agree"
                  class="btn btn-sm btn-primary"
                  style="white-space: nowrap"
              >
                <i class="bi bi-check-circle"></i> Утвердить
              </button>

              <button
                  v-if="!['agree', 'disagree'].includes(event.status)"
                  @click="saveAction('wait')"
                  class="btn btn-sm btn-primary mx-2"
                  ref="wait"
                  style="white-space: nowrap"
              >
                <i class="bi bi-save"></i> Сохранить
              </button>

              <button v-if="event.status === 'wait'" ref="disagree" @click="saveAction('disagree')"
                      class="btn btn-sm btn-danger text-white" style="white-space: nowrap">
                <i class="bi bi-x-square"></i> Отклонить
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
